export default "__VITE_ASSET__989f7d6e__"